import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormArray, Validators } from '@angular/forms';
import { KundeDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/kunde-dto';
import { TilvalgGroupDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { PostnummerServicePartnerEntity } from 'src/app/api/models/OK/Egis/Service/Models/Entities/postnummer-service-partner-entity';
import { TilvalgDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/tilvalg-dto';

@Component({
    selector: 'app-tilvalg-form',
    templateUrl: './tilvalg-form.component.html',
    styleUrls: ['./tilvalg-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TilvalgFormComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() tilvalgGroups: TilvalgGroupDto[];
  private _kunde: KundeDto;
  @Input() set kunde(kunde: KundeDto) {
    this._kunde = kunde;
    if (kunde) {
      this.isPrivatKunde = kunde.kundetype.id == 1;
    }
  }
  @Input() partner: PostnummerServicePartnerEntity;

  get kunde(): KundeDto {
    return this._kunde;
  }

  @Output() submit: EventEmitter<void> = new EventEmitter();

  fixedPriceEnabled: boolean = false;
  rabatPriceEnabled: boolean = false;

  minEndDate: Date = new Date();

  fixedPriceMinStartDate: Date = new Date();

  tabIndex: number;
  isPrivatKunde: boolean = false;

  hasRights: boolean = false;

  unsubscribe$ = new Subject<void>();

  get rabatEnabled() {
    return this.form.get('rabatEnabled');
  }

  get rabatProcent() {
    return this.form.get('rabatProcent');
  }

  get rabatTekst() {
    return this.form.get('rabatTekst');
  }

  get rabatSplit() {
    return this.form.get('rabatSplit');
  }

  get rabatKontant() {
    return this.form.get('rabatKontant');
  }

  get rabatkampagne() {
    return this.form.get('rabatkampagne');
  }

  get fastPrisEnabled() {
    return this.form.get('fastPrisEnabled');
  }

  get fastPris() {
    return this.form.get('fastPris');
  }

  get fixedPriceStartDate() {
    return this.form.get('fixedPriceStartDate');
  }

  get fixedPriceEndDate() {
    return this.form.get('fixedPriceEndDate');
  }

  constructor(private auth: AuthService) {
    this.hasRights = this.auth.isAdministrator || this.auth.isSuperuser;
  }

  ngOnInit(): void {
    this.fastPrisEnabled.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      this.fixedPriceEnabled = val;
      if (val) {
        this.fastPris.setValidators([Validators.required]);
        this.fixedPriceStartDate.setValidators([Validators.required]);
      } else {
        this.fastPris.clearValidators();
        this.fixedPriceStartDate.clearValidators();
        this.fixedPriceEndDate.clearValidators();
      }
      this.fastPris.updateValueAndValidity();
      this.fixedPriceStartDate.updateValueAndValidity();
      this.fixedPriceEndDate.updateValueAndValidity();
    });

    this.fixedPriceStartDate.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((val) => {
      if (val) {
        this.minEndDate = val;
      }
    });

    this.rabatEnabled.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((enabled) => {
      if (!enabled) {
        this.rabatKontant.clearValidators();
        this.rabatKontant.setValue(null);
        this.rabatProcent.clearValidators();
        this.rabatProcent.setValue(null);
        this.rabatSplit.setValue(null);
        this.rabatSplit.clearValidators();
        this.rabatTekst.setValue(null);
        this.rabatTekst.clearValidators();
        this.rabatkampagne.setValue(null);

        this.rabatKontant.updateValueAndValidity();
        this.rabatProcent.updateValueAndValidity();
        this.rabatSplit.updateValueAndValidity();
        this.rabatTekst.updateValueAndValidity();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  disableTilvalg(tilvalg: TilvalgDto) {
    const frieTilkaldNr = [5, 6, 9, 10, 11, 12, 13, 14, 17, 18, 20, 21, 22];
    if (this.partner && this.partner.allowFrieTilkald == false && frieTilkaldNr.includes(tilvalg.tilvalgnr)) {
      return true;
    }
    return false;
  }

  getToolTip(value: boolean) {
    return value == true ? 'Partner tillader ikke frie tilkald' : '';
  }

  onOptionChange() {}

  getTilvalgGroup() {}
}
